var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('creator-video-guide'),(!_vm.modal)?_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"primary","pill":"","block":"","size":"lg"},on:{"click":_vm.finished}},[_vm._v(" Ok, got it ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }